import React from 'react';
import axios from 'axios';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import DatasetInfo from './dataset_info.jsx';

//import { withAuthenticator } from 'aws-amplify-react';

const styles = theme => ({
    root: {
        width: '100%',
    }
});

class Dataset extends React.Component {
    state = {
        dataset: {},
        loading: true,
    };

    componentDidMount() {
        axios.get(`${process.env.REACT_APP_API_URL}/api/dataset/${this.props.match.params.id}`)
            .then(res => {
                const dataset = res.data;

                this.setState({ dataset, loading: false })
            })
    }

    render() {
        const { classes  } = this.props;
        const { dataset } = this.state;

        return (
            <div className={classes.root}>
                <Typography variant="headline" gutterBottom>{dataset && dataset.fields && dataset.fields.name}</Typography>
                <Grid container className={classes.gridContainer} spacing={16}>
                    <Grid item lg={6} md={12}>
                        <p>Foo</p>
                    </Grid>
                    <Grid item lg={6} md={12}>
                        <DatasetInfo dataset={dataset} />
                    </Grid>
                </Grid>
                <Grid container className={classes.gridContainer} spacing={16}>
                    <Grid item xs={12}>
                        <p>bar</p>
                    </Grid>
                </Grid>

            </div>
        );
    }
}


export default withStyles(styles)(Dataset);



// WEBPACK FOOTER //
// ./src/components/dataset.jsx